module.exports = __webpack_public_path__ + "img/soundCorrect.735b5282.svg";